export class RegistrationCode
{
    Id!: number;
    Code!: string;
    MembershipTypeId!: number;
    AssignNoCategories = false;

    constructor(json?: any)
    {
        if (json)
        {
            Object.assign(this, json);
        }
    }
}
